import { Box, Stack, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';

import { Laboratory } from '@/module/Laboratory/model/LaboratoryTypes';

import { NoContentPlaceholder } from '@/core/components';

import { Id } from '@feature/utils';

import { LaboratoryCard } from './components/Card/LaboratoryCard';

interface LaboratoryBrowseProps {
  labs: Laboratory[];
  researchCenterId: Id;
}

export function LaboratoryBrowse({ researchCenterId, labs }: LaboratoryBrowseProps) {
  const { t } = useTranslation();

  return (
    <Stack>
      <Text
        size="2xl"
        fw="500"
      >
        {t('laboratories.title')}
      </Text>
      {labs != null && labs.length > 0 ? (
        <Box>
          <Stack>
            {labs.map(item => (
              <LaboratoryCard
                key={item.id}
                laboratory={item}
                to={`/research-center/${researchCenterId}/lab/${item.id}`}
              />
            ))}
          </Stack>
        </Box>
      ) : (
        <NoContentPlaceholder title={t('noContent.title')} />
      )}
    </Stack>
  );
}
